var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nolist-box"},[_c('img',{attrs:{"src":require("@/assets/e_commerce_request_error_icon.png")}}),_c('p',[_vm._v(_vm._s(_vm.text||'暂无数据'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }